import { createVuetify } from 'vuetify'

import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { mdi } from 'vuetify/iconsets/mdi-svg'

const vuetify = createVuetify({
    ssr: true,
    components,
    directives,
    VBtn: {
        ripple: false,
    },
    icons: {
        defaultSet: 'mdi',
        sets: {
            mdi,
        },
    },
    theme: {
        defaultTheme: 'dark'
    },
})

export default vuetify